function _replaceWithFallback(url) {
    if (url.includes('fallback')) return url;
    return url.replace(/svc-(\d+)-/, 'svc-$1-fallback-');
}

async function fetchDataWithRetry(primaryUrl, backupUrl, maxRetries = 10) {
    for (const url of [primaryUrl, backupUrl]) {
        for (let attempt = 0; attempt <= maxRetries; attempt++) {
            try {
                const response = await fetch(url);
                if (response.ok) return response;
                throw new Error(`Failed to fetch data: ${response.status}`);
            } catch (error) {
                console.error(error);
                if (attempt < maxRetries) {
                    console.log(`Retrying (${attempt + 1}/${maxRetries})...`);
                } else if (url === primaryUrl) {
                    console.error(`Max retries (${maxRetries}) reached for primary URL. Switching to backup server.`);
                    console.log('Retrying with backup server...');
                } else {
                    throw new Error('Max retries reached for both primary and backup URLs.');
                }
            }
        }
    }
}

function sortByKey(array, key) {
    return [...array].sort((a, b) => {
        const x = a[key], y = b[key];
        if (x === 'Towbar Kits') return -1;
        if (y === 'Towbar Kits') return 1;
        return x.localeCompare(y, undefined, { sensitivity: 'base' });
    });
}

function isEmpty(obj) {
    for (const prop in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, prop)) return false;
    }
    return true;
}

function copyObj(r) {
    return JSON.parse(JSON.stringify(r));
}

function sortYearValues(values) {
    values.sort((a, b) => {
        const aa = Date.parse(a.label.split(' - ')[0].split('/').join('/1/'));
        const bb = Date.parse(b.label.split(' - ')[0].split('/').join('/1/'));
        if (!aa) return -1;
        if (!bb) return 1;
        return aa < bb ? 1 : aa > bb ? -1 : 0;
    });
}

function applyFacetsToFilters(filters, facetsResponse, startIndex = 0) {
    for (let j = startIndex; j < filters.length; j++) {
        for (const facetResponse of facetsResponse) {
            if (facetResponse.facetName === filters[j].key) {
                filters[j].values = sortByKey(copyObj(facetResponse.labels), 'label');
                if (facetResponse.id !== undefined) filters[j].id = facetResponse.id;
            }
        }
    }
    const datesMM = filters.find(m => m.key === 'metafield:global.vehicle_year');
    if (datesMM) sortYearValues(datesMM.values);
    return filters;
}

const template = `
<div class="container mar-bottom-20">
  <div class="section-filter-v2">
      <div class="azirspares-heading">
        <h3><span>FIND MY FIT</span></h3>
          <button style="margin-left:20px;" v-if="submited" @click="clearFilters">Clear Filters</button>
      </div>
  </div>

  <div class=" container--flush mar-top-30 mar-bottom-30 px-sm-4 filter-group engojs-filter-v2-wrapper" style="position:relative">
  	<loading :active.sync="loadingShow" :is-full-page="false"></loading>
     <div class="card">
        <div class="card__section card__section--tight">
           <form class="ymm-form" novalidate>
              <div class="product-list f-list" style="overflow: visible;" v-for="(f,index) in ymmFiltersData" :key="f['key']">
                 <div class="col col-md-3 col-lg-2 f-item">
                    <Multiselect
                        v-model="f['selectedValues']"
                        @clear="changedFacets(index)"
                        @select="changedFacets(index)"
                        @deselect="changedFacets(index)"
                        :close-on-select="false"
                        :options="f['values']"
                        :placeholder="f['placeholder']"
                        v-bind="multiSelectProps"
                        :loading="loadingShow"
                        :disabled="ymmFilterSelectType === 1 && index>0 && ymmFiltersData[index-1] && ymmFiltersData[index-1]['selectedValues'] && ymmFiltersData[index-1]['selectedValues'].length == 0"
                    ></Multiselect>
                 </div>
              </div>

              <div class="product-list f-list" style="overflow: visible;" >
                 <div class="col col-md-2 f-item">
                    <button class="button button--primary save_data" type="button" @click="submit" style="">Search</button>
                 </div>
              </div>
           </form>
        </div>
     </div>
  </div>
</div>
`

const { createApp } = Vue;

const app = createApp({
    data() {
        return {
            ymmFiltersData: copyObj(ymmFilters),
            loadingShow: 1,
            multiSelectProps: {
                valueProp: 'label',
                searchable: true,
                mode: 'tags'
            },
            submited: false,
            ymmFilterSelectType: 1,
            showConfirmStep: 1
        }
    },
    template,
    async created() {
        await this.init();
        const ymmCookieData = location.pathname === sessionStorage.getItem('usf_pathname') || location.pathname !== '/search'
            ? '[]'
            : Cookies.get('ymm');
        let count = 0;
        try {
            const ymmCookieJson = JSON.parse(ymmCookieData);
            for (const cookieFacet of ymmCookieJson) {
                for (let j = 0; j < this.ymmFiltersData.length; j++) {
                    if (cookieFacet.key === this.ymmFiltersData[j].key) {
                        this.ymmFiltersData[j].selectedValues = cookieFacet.selectedValues;
                        count++;
                    }
                }
            }
            if (count > 0) this.submited = true;
        } catch (e) {
            console.log('error : ', e);
            Cookies.set('ymm', '[]');
            this.submited = false;
        }
        sessionStorage.setItem('usf_pathname', location.pathname);
    },

    methods: {
        clearFilters() {
            for (const filter of this.ymmFiltersData) {
                filter.selectedValues = [];
            }
            Cookies.set('ymm', '[]');
            this.submited = false;
            this.changedFacets(0);
            this.browseItems();
        },
        browseItems() {
            window.location.href = this.submitUrl;
        },
        submit(e) {
            e.preventDefault();

            if (!this.currentFacets) {
                Toastify({
                    text: 'You need to select at least one field',
                    duration: 3000,
                    newWindow: true,
                    close: true,
                    gravity: 'top',
                    position: 'right',
                    stopOnFocus: true,
                    style: { background: 'linear-gradient(to right, #ff5f6d, #ffc371)' }
                }).showToast();
                return;
            }

            const copiedYmmFilterData = copyObj(this.ymmFiltersData);
            for (const f of copiedYmmFilterData) f.values = [];
            Cookies.set('ymm', JSON.stringify(copiedYmmFilterData));
            this.submited = true;
            this.browseItems();
        },
        async changedFacets(index) {
            this.loadingShow = true;
            const startIndex = this.ymmFilterSelectType === 1 ? index + 1 : 0;
            for (let j = startIndex; j < this.ymmFiltersData.length; j++) {
                this.ymmFiltersData[j].values = [];
            }
            await new Promise(resolve => setTimeout(resolve, 100));

            fetchDataWithRetry(this.getAPIEndpoint, this.getAPIEndpointFallback)
                .then(response => response.json())
                .then(data => {
                    if (data.data && data.data.facets) {
                        this.ymmFiltersData = applyFacetsToFilters(copyObj(this.ymmFiltersData), data.data.facets, startIndex);
                    }
                })
                .then(() => { this.loadingShow = false; })
                .catch(e => console.error(e));
        },

        async init() {
            this.loadingShow = true;
            const cloned = copyObj(this.ymmFiltersData);
            await fetchDataWithRetry(this.getAPIEndpoint, this.getAPIEndpointFallback)
                .then(response => response.json())
                .then(data => {
                    if (data.data && data.data.facets) {
                        this.ymmFiltersData = applyFacetsToFilters(cloned, data.data.facets);
                    }
                })
                .then(() => { this.loadingShow = false; });
        },
    },

    computed: {
        submitUrl() {
            const p = {};
            for (const filter of this.ymmFiltersData) {
                if (filter.selectedValues.length) {
                    const id = 'uff_' + parseInt(filter.id).toString(36) + '_' + filter.key;
                    p[id] = filter.selectedValues.map(String).join('_usf_');
                }
            }
            const s = new URLSearchParams(p).toString().replace(/%7C/g, '_usf_');
            return '/search?' + s;
        },

        currentFacets() {
            const f = {};
            for (const filter of this.ymmFiltersData) {
                if (filter.selectedValues.length) {
                    f[filter.id] = [filter.key, filter.selectedValues];
                }
            }
            return isEmpty(f) ? false : f;
        },

        currentFacetsString() {
            if (!this.currentFacets) return '';
            return this.ymmFiltersData
                .filter(filter => filter.selectedValues.length)
                .map(filter => filter.selectedValues.join(','))
                .join(' | ');
        },

        getAPIEndpoint() {
            const p = {
                q: '',
                apiKey: usf.settings.siteId,
                skip: 0,
                take: 1
            };
            if (this.currentFacets) p.facetFilters = JSON.stringify(this.currentFacets);
            return usf.settings.searchSvcUrl + 'search?' + new URLSearchParams(p);
        },

        getAPIEndpointFallback() {
            return _replaceWithFallback(this.getAPIEndpoint);
        }
    }
});

app.use(VueLoading.Plugin);
app.component('loading', VueLoading.Component);
app.component('Multiselect', VueformMultiselect);

document.addEventListener('DOMContentLoaded', function() {
    app.mount('#ymm_app');

    const ymmHeading = document.querySelector('.azirspares-heading');
    if (ymmHeading) {
        ymmHeading.addEventListener('click', function() {
            document.body.classList.toggle('show-ymm');
        });
    }
});